import { styled } from "@vw-marketing/us-components";

export const StyledTitleContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static100};

  p {
    color: #000E26 !important;
  }
`;